<template>
  <div class="layout-full-page">
    <div class="container">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout-full-page'
}
</script>

<style>
.layout-full-page {
    height: 100vh;
    display: flex;
    align-items: center;
}

.login {
    font-family: Arial, Helvetica, sans-serif;
}

.login-section {
    height: 100vh;
    display: flex;
    align-items: center;
}

.login-wrap {
    width: 100%;
    overflow: hidden;
    background: #fff;
    border-radius: 1rem;
    box-shadow: 5px 5px 5px 0 #ced1e4;
}

.login-img {
    background-image: url('~@/assets/img/standaard-kind-op-speeltoestel.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 25%;
    width: 100%;
    height: 250px;
}

.login-box {
    position: relative;
    width: 100%;
}

.login-logo img {
    max-width: 90%;
}

.login .input-group .btn {
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-left-width: 0;
}

.login .input-group .btn:hover i {
    color: #39b3d7;
}

.login .input-group .form-control {
    border-right-width: 0;
}

.login .form-label {
    margin-bottom: .25rem;
    font-size: .75rem;
    color: var(--bs-secondary-color);
}

@media (min-width: 768px) {
    .login-img {
        background-position-y: center;
        width: 40%;
        height: auto;
    }

    .login-box {
        width: 60%;
    }
}
</style>
